/**
 * After a real first save: do not reopen Create from a stale request.
 * A later click (Cost another dish) increments requestOpenCreate and may open.
 */

export function shouldOpenCreateFromRequest({
  requestOpenCreate,
  lastOpenedRequest,
} = {}) {
  const next = Number(requestOpenCreate) || 0
  const last = Number(lastOpenedRequest) || 0
  if (!Number.isFinite(next) || !Number.isFinite(last)) return false
  return next > last
}
